<!-- Page Header -->
<div class="page-header" *ngIf="config">
  <div class="page-header-left">
    <div class="page-header-icon"
      [ngClass]="tipoSelecionado === 'ENTRADA' ? 'icon-entrada' : 'icon-saida'">
      <i [class]="config.icone"></i>
    </div>
    <div class="page-header-text">
      <h1>{{ config.titulo }}</h1>
      <p>{{ config.subtitulo }}</p>
    </div>
  </div>
</div>

<!-- Table Card -->
<div class="table-card" *ngIf="config">
  <div class="card-header card-header-table">
    <div class="card-header-left">
      <div class="card-header-icon"
        [ngStyle]="{ 'background': config.tableIconBg }">
        <i [class]="config.tableIcon" [ngStyle]="{ 'color': config.tableIconColor }"></i>
      </div>
      <span class="card-header-title">{{ tituloCard }}</span>
    </div>
    <div class="card-header-filters">
      <!-- Busca -->
      <div class="header-filter-field header-filter-field-search">
        <span class="p-input-icon-left" style="width: 100%">
          <i class="pi pi-search"></i>
          <input
            type="text"
            pInputText
            placeholder="  Buscar por pessoa..."
            [value]="searchNome"
            (input)="onSearchInput($event)"
            aria-label="Buscar por pessoa"
            style="width: 100%; padding-left: 2.5rem" />
        </span>
      </div>
      <!-- Conta -->
      <div class="header-filter-field header-filter-field-conta">
        <p-dropdown
          [options]="contas"
          [(ngModel)]="contaSelecionada"
          [showClear]="true"
          [placeholder]="labels.todas_as_contas"
          [loading]="loadingContas"
          optionLabel="label"
          optionValue="value"
          (onChange)="onFiltroChange()"
          appendTo="body"
          panelStyleClass="dropdown-panel-above-modal"
          [style]="{ width: '100%' }">
          <ng-template pTemplate="selectedItem">
            <div class="dropdown-conta-item" *ngIf="contaSelecionada !== null && contaSelecionada !== undefined">
              <img *ngIf="getContaFlagUrl(contaSelecionada)" [src]="getContaFlagUrl(contaSelecionada)" class="flag-icon-small" alt="" />
              <span>{{ getContaLabel(contaSelecionada) }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-conta>
            <div class="dropdown-conta-item">
              <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
              <span>{{ conta.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <!-- Periodo -->
      <div class="header-filter-field">
        <app-periodo-filtro
          modo="avancado"
          [valorPadrao]="'showAll'"
          [persistir]="true"
          [textoExibicao]="periodoSelecionado.texto"
          styleClass="w-full"
          (periodoChanged)="onPeriodoChange($event)">
        </app-periodo-filtro>
      </div>
      <!-- Situacao -->
      <div class="header-filter-field">
        <p-dropdown
          [options]="situacaoOptions"
          [(ngModel)]="situacaoSelecionada"
          optionLabel="label"
          optionValue="value"
          (onChange)="onSituacaoChange()"
          [style]="{ width: '100%' }">
        </p-dropdown>
      </div>
    </div>
    <!-- Seletor de colunas -->
    <app-column-selector
      [columns]="columns"
      [storageKey]="STORAGE_KEY"
      (columnsChange)="onColumnsChange($event)">
    </app-column-selector>
  </div>

  <!-- Cards de Totais por Moeda (dentro do table-card, entre header e tabela) -->
  <app-resumo-totais
    [cardsTotais]="cardsTotaisFiltrados"
    [loading]="loadingTotais"
    [filtroMoedaSelecionada]="filtroMoedaSelecionada"
    (moedaClicada)="onMoedaClicada($event)">
  </app-resumo-totais>

  <div class="card-content">
    <!-- Tabela unificada para ENTRADA e SAIDA -->
    <app-lista-despesas
      [despesas]="titulos"
      [loading]="loading"
      [tipoTela]="tipoSelecionado"
      [totalRecords]="totalRecords"
      [first]="first"
      [rows]="rows"
      (pageChanged)="onPageChange($event)"
      (sortChanged)="onSortChanged($event)"
      (tituloClicado)="onTituloClicado($event)">
    </app-lista-despesas>
  </div>
</div>
